import { render, staticRenderFns } from "./autoShopCustomer.vue?vue&type=template&id=4bbe194d&"
import script from "./autoShopCustomer.vue?vue&type=script&lang=js&"
export * from "./autoShopCustomer.vue?vue&type=script&lang=js&"
import style0 from "./autoShopCustomer.vue?vue&type=style&index=0&id=4bbe194d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports